import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import { SWAL_SETTINGS, PHONE_NO_LENGTH, INPUT_MAX_25, TEXTAREA_MAX_LENGTH, languageSpoken, EXPERTISE, GENDER, INPUT_LENGTH_25, INPUT_LENGTH_20, INPUT_LENGTH_100 } from "../../../../utils/Constants";
import {
  handleServerValidations,
  DT,
  globalLoader,
  convertTimezoneToOffset
} from "../../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../../utils/customError";
import { useTranslation } from "react-i18next";
import { DatePicker, TagPicker, Tooltip, Whisper } from "rsuite";
import PhoneInput from "../../../../utils/PhoneInput";
import logo from '../../../../assets/admin/img/calenderLogo.png';
import { userDetails, userEdit } from "../../services/user.service";
import { useLoadScript } from '@react-google-maps/api';

const CustomBase64Caret = () => (
  <img
    src={logo}
    alt="Custom Caret"
    style={{ width: 20, height: 20 }}
  />
);

const LIBRARIES = ['places'];
const UserEdit = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  const [previewimage, setPreviewImage] = useState("");
  const [saveType, setSaveType] = useState("");
  const [isPlaceSelected, setIsPlaceSelected] = useState(false);
  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("User"),
      url: "/admin/user-management/user/list/1",
    },
    { title: t("Edit"), url: "" },
  ];

  useEffect(() => {
    userDetails(params.id)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
        setPreviewImage(response?.data?.profile_image);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);


  const validationSchema = Yup.object().shape({
    name: Yup.string().trim().max(100, "max_length_error").matches(/^[a-zA-Z\s]+$/, "Name can only contain alphabets and spaces").required("Name is required"),
    // last_name: Yup.string().trim().max(100, "max_length_error").required("Last name is required"),
    // email: Yup.string()
    //   .trim()
    //   .email("label_email_invalid_format_error")
    //   .test('no-uppercase', "label_email_uppercase_error", function (value) {
    //     if (value) {
    //       return !/[A-Z]/.test(value);
    //     }
    //     return true;
    //   })
    //   .required("label_email_required_error"), 
    // email: EMAIL_VALIDATION,
    // phone_number: PHONE_VALIDATION,
    gender: Yup.string().trim().required("Gender is required"),
    // date_of_birth: Yup.string().trim().required("Date of Birth is required"),
    date_of_birth: Yup.string()
        .required(t("Date of Birth is required"))
        .test(
          "valid-date",
          t("Invalid date"),
          value => {
            if (!value) return false;
            const date = new Date(value);
            if (isNaN(date.getTime())) return false; // invalid date format
    
            const today = new Date();
            if (date > today) return false; // future date not allowed
    
            const earliestDate = new Date();
            earliestDate.setFullYear(today.getFullYear() - 120); // e.g. max 120 years ago
            if (date < earliestDate) return false; // too far in past
    
            return true;
          }
        ),
    time_of_birth: Yup.string().trim().required("Time of Birth is required"),
    // place_of_birth: Yup.string().max(TEXTAREA_MAX_LENGTH, DT(t("validation_max_input_characters"), [TEXTAREA_MAX_LENGTH])).required("Place of Birth is required"),
    // place_of_birth: Yup.string()
    //   .required(t("Address is required"))
    //   .test('is-place-selected', t("Please select an address from the dropdown"), function(value) {
    //     const { latitude, longitude } = this.parent; // access sibling fields
    //     return latitude && longitude; // require lat/lng to be present
    //   }),
    place_of_birth: Yup.string()
      .required("Address is required")
      .test('is-google-place-selected', "Please select an address from the dropdown", function(value) {
        const { latitude, longitude } = this.parent;
        return !!(latitude && longitude);
      }),

    profile_image: Yup.mixed()
      .required(t('image_required_error'))
      .nullable()
      .test(
        'fileOrUrl',
        'supported_file_error',
        value => {
          if (!value) return true;
          if (typeof value === 'string') return /^(http|https):\/\/[^\s$.?#].[^\s]*$/gm.test(value);
          return ['image/jpg', 'image/jpeg', 'image/png', 'image/webp', 'image/gif'].includes(value.type);
        }
      )
      .test(
        'fileSize',
        'image_max_size_error',
        value => {
          if (!value || typeof value === 'string') return true;
          return value.size <= 5 * 1024 * 1024;
        }
      ),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: showdefault && showdefault.name ? showdefault.name : "",
      // last_name: showdefault && showdefault.last_name ? showdefault.last_name : "",
      email: showdefault && showdefault.email ? showdefault.email : "",
      phone_number: showdefault && showdefault?.phone_number ? showdefault?.phone_number : "",
      gender: showdefault && showdefault.gender ? showdefault.gender : "",
      date_of_birth: showdefault && showdefault.date_of_birth ? showdefault.date_of_birth : "",
      time_of_birth: showdefault && showdefault.time_of_birth ? showdefault.time_of_birth : "",
      place_of_birth: showdefault && showdefault.place_of_birth ? showdefault.place_of_birth : "",
      latitude: showdefault && showdefault.latitude ? showdefault.latitude : "",
      longitude: showdefault && showdefault.longitude ? showdefault.longitude : "",
      timezone: showdefault && showdefault.timezone ? showdefault.timezone : "",
      profile_image: showdefault && showdefault.profile_image ? showdefault.profile_image : "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      globalLoader(true);
      let formData = new FormData();
      formData.append("o_id", params.id);
      formData.append("name", values.name);
      // formData.append("last_name", values.last_name);
      formData.append("email", values.email);
      formData.append("phone_number", values.phone_number);
      formData.append("gender", values.gender);
      formData.append("date_of_birth", values.date_of_birth);
      formData.append("time_of_birth", values.time_of_birth);
      formData.append("place_of_birth", values.place_of_birth);
      formData.append("latitude", values.latitude);
      formData.append("longitude", values.longitude);
      formData.append("timezone", values.timezone);
      formData.append("profile_image", values.profile_image);
      userEdit(formData)
        .then((response) => {
          setSubmitting(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            if (saveType !== "Save") {
              navigate(`/admin/user-management/user/list/1`);
            }
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
          globalLoader(false);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(error),
            ...SWAL_SETTINGS,
          });
          console.log("error ====> ", error);
        });
    },
  });

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY, 
    libraries: LIBRARIES, 
  });

  const inputRef = useRef(null);

  useEffect(() => {
    if (isLoaded && window.google && inputRef.current) {
      const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
        types: ['geocode'], // Restrict to address types
      });

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (place && place.geometry) {
          const latitude = place.geometry.location.lat();
          const longitude = place.geometry.location.lng();

          formik.setFieldValue('place_of_birth', place.formatted_address);
          formik.setFieldValue('latitude', latitude);
          formik.setFieldValue('longitude', longitude);

          // formik.setFieldValue('place_details', place);
          const timestamp = new Date().getTime() / 1000; // Current time in Unix timestamp format
          const timezoneUrl = `https://maps.googleapis.com/maps/api/timezone/json?location=${latitude},${longitude}&timestamp=${timestamp}&key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}`;

          // Fetch the timezone information
          fetch(timezoneUrl)
            .then((response) => response.json())
            .then((data) => {
              if (data.status === 'OK') {
                // Extract and set the timezone
                const timezoneId = data.timeZoneId;
                formik.setFieldValue('timezone', convertTimezoneToOffset(timezoneId));
                setIsPlaceSelected(true);
                console.log('Timezone:', convertTimezoneToOffset(timezoneId));
                console.log('data time zone====---->:', data);
              } else {
                console.error('Error fetching timezone:', data);
              }
            })
            .catch((error) => {
              console.error('Error:', error);
            });

        }
      });
    }
  }, [isLoaded]);

  if (loadError) return <div>Failed to load Google Maps API</div>;

  const handleInputChange = (e) => {
    setIsPlaceSelected(false);
    formik.setFieldValue('place_of_birth', e.target.value);
    formik.setFieldValue('latitude', '');
    formik.setFieldValue('longitude', '');
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <form onSubmit={formik.handleSubmit}>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12 animation_fade">
            <div className="card custom-card">
              <div className="card-body">
                <div>
                  <h6 className="main-content-label mb-3">
                    {t("Edit User")}
                  </h6>
                </div>
                <div className="row row-sm">

                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="name" className="text-left d-flex">
                      {t("Name")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="name"
                      id="name"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                      className="form-control"
                      placeholder={t("Enter name")}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError shortCodes={[INPUT_MAX_25]} name="name" form={formik} />
                    </span>
                  </div>
                  {/* <div className="col-md-6 text-center form-group">
                    <label htmlFor="last_name" className="text-left d-flex">
                      {t("Last name")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="last_name"
                      id="last_name"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.last_name}
                      className="form-control"
                      placeholder={t("Enter last name")}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError shortCodes={[INPUT_MAX_25]} name="last_name" form={formik} />
                    </span>
                  </div> */}
                  {showdefault?.login_with === 'email' && 
                  <div className="col-lg-6 text-center form-group">
                    <label htmlFor="email" className="text-left d-flex">
                      {t("label_email")}:<span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="email"
                      id="email"
                      type="email"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                      className="form-control"
                      placeholder={t("placeholder_email")}
                      disabled={formik?.values?.email ? true : false}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="email" form={formik} />
                    </span>
                  </div>}

                  {showdefault?.login_with === 'phone_number' && 
                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex" htmlFor="phone_number">
                      {t("label_phone_number")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    {/* <PhoneInput
                      name="phone_number"
                      id="phone_number"
                      placeholder={t('placeholder_phone_number')}
                      onChange={(e) => { formik.setFieldValue('phone_number', e?.phone_number) }}
                      onBlur={formik.handleBlur}
                      value={formik.values.phone_number}
                      className="form-control"
                      disabled={true}
                    /> */}
                    <input
                      name="phone_number"
                      id="phone_number"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.phone_number}
                      className="form-control"
                      placeholder={t("placeholder_phone_number")}
                      disabled={true}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="phone_number" form={formik} shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                    </span>
                  </div>}

                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="gender" className="text-left d-flex">
                      {t("Gender")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <div className=" select-down-arrow">
                      <select
                        name="gender"
                        id="gender"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.gender}
                        className="form-control" >
                        {(GENDER).map((gender, i) => {
                          return (
                            <option key={i} value={gender}>{t(`${gender}`)}</option>
                          )
                        })}
                      </select>
                      <span className="text-danger d-flex text-left">
                        <CustomError name="gender" form={formik} />
                      </span>
                    </div>
                  </div>

                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="date_of_birth" className="text-left d-flex">
                      {t("Date of birth")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <DatePicker
                      oneTap={true}
                      classPrefix="userInput"
                      placeholder={t("placeholder_date")}
                      placement="autoVertical"
                      format="dd/MM/yyyy"
                      cleanable={false}
                      editable={false}
                      name="date_of_birth"
                      shouldDisableDate={(date) => date > new Date()}
                      onChange={(e) => {
                        formik.setFieldTouched("date_of_birth", true);
                        formik.setFieldValue("date_of_birth", e);
                      }}
                      value={new Date(formik.values.date_of_birth)}
                      onBlur={formik.handleBlur}
                      caretAs={CustomBase64Caret}
                    />
                    {/* <CustomError name="date_of_birth" form={formik} className="text-danger" /> */}
                    <span className="text-danger d-flex text-left">
                      <CustomError name="date_of_birth" form={formik} />
                    </span>
                  </div>

                  {/* <div className="col-md-6 text-center form-group">
                    <label htmlFor="time_of_birth" className="text-left d-flex">
                      {t("Time of Birth")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <DatePicker
                      classPrefix="userInput"
                      placement="autoVertical"
                      format="HH:mm"
                      cleanable={false}
                      editable={true}
                      name="time_of_birth"
                      onChange={(e) => {
                        formik.setFieldTouched("time_of_birth", true);
                        formik.setFieldValue("time_of_birth", e);
                      }}
                      value={new Date(formik.values.time_of_birth)}
                      onBlur={formik.handleBlur}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="time_of_birth" form={formik} />
                    </span>
                  </div> */}

                  <div className="col-md-6 form-group">
                    <label className="text-left d-flex">
                      {t("Time of Birth")}:
                      <span className="requirestar">*</span>
                    </label>
                    <input
                      type={formik.values.time_of_birth ? "time" : "text"}
                      placeholder={t("Select time")}
                      name="time_of_birth"
                      onChange={formik.handleChange}
                      onFocus={(e) => {
                        e.target.type = "time";
                        try { e.target.showPicker && e.target.showPicker(); } catch (err) {}
                      }}
                      onClick={(e) => {
                        e.target.type = "time";
                        try { e.target.showPicker && e.target.showPicker(); } catch (err) {}
                      }}
                      onBlur={(e) => {
                        if (!e.target.value) e.target.type = "text";
                        formik.handleBlur(e);
                      }}
                      value={formik.values.time_of_birth || ""}
                      className="form-control"
                      style={{ color: formik.values.time_of_birth ? "inherit" : "#999" }}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="time_of_birth" form={formik} />
                    </span>
                  </div>


                  {/* <div className="col-md-6 text-center form-group">
                    <label htmlFor="place_of_birth" className="text-left d-flex">
                      {t("Place of Birth")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="place_of_birth"
                      id="place_of_birth"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.place_of_birth}
                      className="form-control"
                      placeholder={t("Enter place of birth")}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError shortCodes={[TEXTAREA_MAX_LENGTH]} name="place_of_birth" form={formik} />
                    </span>
                  </div> */}

                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="place_of_birth" className="text-left d-flex">
                      {t('label_address')}:
                      <span className="requirestar">*</span>{' '}
                    </label>
                    <input
                      name="place_of_birth"
                      id="place_of_birth"
                      type="text"
                      ref={inputRef}
                      autoComplete="off"  
                      // onChange={formik.handleChange}
                      onChange={handleInputChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.place_of_birth}
                      className="form-control"
                      placeholder={t('placeholder_address')}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError shortCodes={['TEXTAREA_MAX_LENGTH']} name="place_of_birth" form={formik} />
                    </span>
                  </div>

                  <div className="col-lg-6 text-center form-group">
                    <label htmlFor="restaurant_logo" className="text-left d-flex">
                      {t("label_profile_image")}:
                      {" "}
                      <Whisper
                        placement="top"
                        controlId="control-id-hover"
                        trigger="hover"
                        speaker={
                          <Tooltip>
                            {t("image_support_tooltip")}
                          </Tooltip>
                        }
                      >
                        <span className="field-more-info mt-1 ms-1 cp">
                          ?
                        </span>
                      </Whisper>
                    </label>
                    <input
                      className="form-control imgInput"
                      id="profile_image"
                      name="profile_image"
                      accept="image/*"
                      type="file"
                      onChange={(event) => {
                        formik.setFieldValue(
                          "profile_image",
                          event.target.files[0] || ""
                        );
                        event.target.files.length === 1
                          ? setPreviewImage(
                            URL.createObjectURL(event.target.files[0])
                          )
                          : setPreviewImage("");
                      }}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="profile_image" form={formik} />
                    </span>
                    {previewimage ? (
                      <ul className="question-image-preview questions-ul">
                        <li className="pr_img_box">
                          <img
                            src={previewimage}
                            style={{ height: "100px" }}
                            alt={"profileImg"}
                          />
                        </li>
                      </ul>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="mt-5">
                    <button
                      onClick={() => {
                        setSaveType("Save");
                      }}
                      className="btn btn-info mr-2"
                      type="submit"
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("btn_save")}
                    </button>
                    <button
                      onClick={() => {
                        setSaveType("");
                      }}
                      className="btn btn-success mr-2"
                      type="submit"
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("btn_save_exit")}
                    </button>
                    <button
                      className="btn ripple btn-secondary"
                      type="button"
                      onClick={() => navigate(-1)}
                    >
                      <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                      {t("btn_cancel")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default UserEdit;